module.exports = __webpack_public_path__ + "img/chargingDetailRunning.f1bb88c1.svg";